import { render, staticRenderFns } from "./watmentw.vue?vue&type=template&id=39ff3635&scoped=true&"
import script from "./watmentw.vue?vue&type=script&lang=js&"
export * from "./watmentw.vue?vue&type=script&lang=js&"
import style0 from "./watmentw.vue?vue&type=style&index=0&id=39ff3635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ff3635",
  null
  
)

export default component.exports